import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
const classNames = require('classnames');

import LoginPage from './auth/LoginPage';
import ScrollToTop from './components/common/ScrollToTop';
import FourOhFourPage from './common/404Page';
import FourOhOnePage from './common/401Page';
import FourOhThreePage from './common/403Page';
import PageFooter from './components/common/PageFooter';
import RequireMultiFactorLoginPage from './auth/RequireMultiFactorLoginPage';
import DuplicateEmailRedirect from './quoting/enrollment/DuplicateEmailRedirect';

import HomePage from './landing/HomePage';
import LandingFirstChildPage from './landing/LandingFirstChildPage';
import AboutUsPage from './common/AboutUsPage';
import FAQPage from './common/FAQPage';

import RunningHomePage from './landing/RunningHomePage';
import HomeonwersHomePage from './landing/HomeownersHomePage';

import QuotingPage from './quoting/QuotingPage';
import QuotingDeclined from './quoting/QuotingDeclined';

import AdminHomePage from './admin/AdminHomePage';
import PickListTypeListPage from './admin/PickList/PickListTypeListPage';
import PickListItemListPage from './admin/PickList/PickListItemListPage';
import PickListItemPage from './admin/PickList/PickListItemPage';
import CustomerListPage from './admin/customers/CustomerListPage';
import CustomerPage from './admin/customers/CustomerPage';
import ProspectPage from './admin/customers/ProspectPage';
import StaffListPage from './admin/staff/StaffListPage';
import StaffPage from './admin/staff/StaffPage';
import GroupListPage from './admin/groups/GroupListPage';
import GroupDetailPage from './admin/groups/GroupDetailPage';
import AdjudicationListPage from './admin/adjudication/AdjudicationListPage';
import CustomerApplicationPaymentPage from './admin/customers/CustomerApplicationPaymentPage';

import ReferralsPage from './admin/reports/ReferralsPage';
import FinancialExportPage from './admin/reports/FinancialExportPage';
import UserActivityPage from './admin/reports/UserActivityPage';
import FailedPaymentsListPage from './admin/reports/FailedPaymentsListPage';
import FailedPaymentDetailsPage from './admin/reports/FailedPaymentDetailsPage';
import MissingBeneficiaryFormsListPage from './admin/reports/MissingBeneficiaryFormsListPage';
import CreatedPoliciesListPage from './admin/reports/CreatedPoliciesListPage';
import UnmailedPoliciesListPage from './admin/reports/UnmailedPoliciesListPage';
import ExpiringPoliciesListPage from './admin/reports/ExpiringPoliciesListPage';
import BouncedEmailsListPage from './admin/reports/BouncedEmailsListPage';
import ReferPage from './user/ReferPage';
import PoliciesPage from './user/PoliciesPage';
import PolicyBeneficiaryPage from './policy/PolicyBeneficiaryPage';
import PolicyBeneficiariesDisbursementPage from './policy/PolicyBeneficiariesDisbursementPage';
import BeneficiariesPage from './user/BeneficiariesPage';
import TransactionsPage from './user/TransactionsPage';
import ProfilePage from './user/ProfilePage';
import UserHomePage from './user/UserHomePage';

import MakeAClaimPage from './claim/MakeAClaimPage';
import { Redirect } from 'react-router';
import ResetPasswordPage from './common/ResetPasswordPage';
import ReferralLinkPage from './common/ReferralLinkPage';
import SpousalReferralLinkPage from './common/SpousalReferralLinkPage';

import MarkPage from './dev/MarkPage';
import ContactUsPage from './common/ContactUsPage';
import TermsPage from './common/TermsPage';
import PrivacyPolicyPage from './common/PrivacyPolicyPage';
import ComplaintsPage from './common/ComplaintsPage';
import CustomSelectYourPlanPage from './quoting/custom/CustomSelectYourPlanPage';
import CampaignUnbouncePage from './landing/CampaignUnbouncePage';
import CampaignPage from './landing/CampaignPage';

class Routes extends React.Component<any, {}> {
	public render() {
		return (
			<ScrollToTop
				className={classNames('page-content-wrapper page-flair-column', {
					'logged-in': true // this.props.auth.token.userId
				})}
				location={this.props.location}
			>
				<Switch>
					<Route path="/login" component={LoginPage} />
					<Route path="/require-multi-factor-login" component={RequireMultiFactorLoginPage} />
					<Route path="/existing-account-found" component={DuplicateEmailRedirect} />
					<Route path="/fourohthree" component={FourOhThreePage} />
					<Route path="/fourohone" component={FourOhOnePage} />

					{/* #region static site content */}
					<Route exact={true} path="/" component={HomePage} />
					<Route exact={true} path="/runningroom" component={RunningHomePage} />
					<Route exact={true} path="/homeowners" component={HomeonwersHomePage} />
					<Route exact={true} path="/life-insurance-and-your-first-child" component={LandingFirstChildPage} />
					<Route exact={true} path="/about-us" component={AboutUsPage} />
					<Route exact={true} path="/faq" component={FAQPage} />
					<Route exact={true} path="/contact-us" component={ContactUsPage} />
					<Route exact={true} path="/terms" component={TermsPage} />
					<Route exact={true} path="/privacy" component={PrivacyPolicyPage} />
					<Route exact={true} path="/complaints" component={ComplaintsPage} />
					{/* #endregion */}

					{/* Redirect from /enrollment to /enrollment/my-pledge */}
					<Route
						exact={true}
						path="/quote/:workflow/enrollment"
						component={({ match: { params } }: any) => (
							<Redirect to={`/quote/${params.workflow}/enrollment/my-pledge`} />
						)}
					/>
					<Route path="/quote/:workflow/:page/:enrollmentPage" component={QuotingPage} />
					<Route path="/quote/:workflow/:page" component={QuotingPage} />
					<Route exact={true} path="/quote/declined" component={QuotingDeclined} />
					<Route path="/quote/:workflow" component={QuotingPage} />

					<Route path="/campaign" component={CampaignPage}/>

					{/* #region administration site */}					
					<Route path="/admin/fourohthree" component={FourOhThreePage} />
					<Route path="/admin/fourohone" component={FourOhOnePage} />

					<Route exact={true} path="/admin/pick-lists/:pickListTypeId/:pickListItemId" component={PickListItemPage} />
					<Route path="/admin/pick-lists/:pickListTypeId" component={PickListItemListPage} />
					<Route path="/admin/pick-lists" component={PickListTypeListPage} />

					{/* Manual Adjudication paths */}
					<Route path="/admin/adjudication" component={AdjudicationListPage} />

					{/* Redirect from /:customerId to /:customerId/details */}
					<Route
						exact={true}
						path="/admin/customers/:customerId"
						component={({ match: { params } }: any) => (
							<Redirect to={`/admin/customers/${params.customerId}/details`} />
						)}
					/>

					<Route
						path="/admin/prospects/:customerId/:tab/:pageId/payment-update"
						component={CustomerApplicationPaymentPage}
					/>
					<Route path="/admin/prospects/:customerId/:tab/:pageId" component={ProspectPage} />
					<Route path="/admin/prospects/:customerId/:tab" component={ProspectPage} />
					<Route path="/admin/prospects/:customerId" component={ProspectPage} />
					<Route path="/admin/customers/:customerId/:tab/:pageId" component={CustomerPage} />
					<Route path="/admin/customers/:customerId/:tab" component={CustomerPage} />
					<Route path="/admin/customers/:customerId" component={CustomerPage} />
					<Route path="/admin/customers" component={CustomerListPage} />

					<Route path="/admin/staff/:userId/:tab" component={StaffPage} />
					<Route path="/admin/staff/:userId" component={StaffPage} />
					<Route path="/admin/staff" component={StaffListPage} />

					<Route path="/admin/group/:groupId" component={GroupDetailPage} /> // todo: delete?
					<Route path="/admin/group" component={GroupListPage} /> // todo: delete?

					<Route path="/admin/reports/user-activity" component={UserActivityPage} />
					<Route exact={true} path="/admin/reports/failed-payments/:id" component={FailedPaymentDetailsPage} />
					<Route path="/admin/reports/failed-payments" component={FailedPaymentsListPage} />
					<Route path="/admin/reports/missing-beneficiary-forms" component={MissingBeneficiaryFormsListPage} />
					<Route path="/admin/reports/policies-created" component={CreatedPoliciesListPage} />
					<Route path="/admin/reports/policies-unmailed" component={UnmailedPoliciesListPage} />
					<Route path="/admin/reports/policies-expiring" component={ExpiringPoliciesListPage} />
					<Route path="/admin/reports/bounced-emails" component={BouncedEmailsListPage} />
					<Route path="/admin/reports/financial-export" component={FinancialExportPage} />
					<Route path="/admin/reports/referrals" component={ReferralsPage} />
					<Route path="/admin" component={AdminHomePage} />
					{/* #endregion administration site */}

					{/* #region customer portal */}
					<Route
						exact={true}
						path="/user/:userId/billing"
						component={({ match: { params } }: any) => (
							<Redirect to={`/user/${params.userId}/billing/view-bills`} />
						)}
					/>
					<Route path="/user/:userId/billing/:tab/:invoiceNumber" component={TransactionsPage} />
					<Route path="/user/:userId/billing/:tab" component={TransactionsPage} />

					<Route path="/user/:userId/policies" component={PoliciesPage} />
					<Route path="/user/:userId/refer" component={ReferPage} />
					<Route path="/user/:userId/beneficiaries/:beneficiaryId" component={PolicyBeneficiaryPage} />
					<Route path="/user/:userId/beneficiaries" component={BeneficiariesPage} />
					<Route path="/user/:userId/beneficiaries-disbursement" component={PolicyBeneficiariesDisbursementPage} />
					<Route path="/user/:userId/profile" component={ProfilePage} />
					<Route path="/user" component={UserHomePage} />
					{/* #endregion customer portal */}

					<Route exact={true} path="/claims" component={MakeAClaimPage} />

					<Route path="/reset-password" component={ResetPasswordPage} />

					<Route path="/refer/:referralCode" component={ReferralLinkPage} />
					<Route path="/refer-spousal/:spousalReferralCode" component={SpousalReferralLinkPage} />
					
					<Route path="/unbounce" component={CampaignUnbouncePage}/>

					<Route path="/dev/mark" component={MarkPage} />
					<Route path="/dev/customPlan" component={CustomSelectYourPlanPage} />

					<Route path="*" component={FourOhFourPage} />
				</Switch>
				<PageFooter />
			</ScrollToTop>
		);
	}
}

export default Routes;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Routes.tsx